import { Fraction } from 'bi-fraction';
import { ConvertibleToShare as ConvertibleToShareAbi, ConvertibleToShares as ConvertibleToSharesAbi, ERC20 as ERC20Abi, Rewarder as RewarderAbi, WCRO as WCROAbi, } from './abis';
import { Bridge } from './bridge';
import { TokenDistributor } from './contracts/tokenDistributor';
import { ZkToken } from './contracts/zkToken';
import { ChainLayer } from './types';
import { getContract, getProvider } from './utils';
export class SDK_L2 {
    constructor(providerOptions, contractAddressMap) {
        this.providerOptions = providerOptions;
        this.contractAddressMap = contractAddressMap;
        this.getContract = (address, abi, signerOrProvider) => {
            if (!signerOrProvider) {
                signerOrProvider = getProvider(this.providerOptions, ChainLayer.L2);
            }
            return getContract(address, abi, signerOrProvider);
        };
        this.getContractAddress = (contractName) => {
            return this.contractAddressMap[contractName];
        };
        this.getERC20 = (address, signerOrProvider) => this.getContract(address, ERC20Abi, signerOrProvider);
        this.getConvertibleToShare = (address) => this.getContract(address, ConvertibleToShareAbi);
        this.getRewarder = (address, signerOrProvider) => this.getContract(address, RewarderAbi, signerOrProvider);
        this.getConvertibleToShares = (address) => this.getContract(address, ConvertibleToSharesAbi);
        this.getWCRO = (signerOrProvider) => this.getContract(this.getContractAddress('WCRO'), WCROAbi, signerOrProvider);
        this.getZkToken = (options) => new ZkToken(options);
        this.getBridge = (l1ProviderOptions) => {
            if (!this.bridge) {
                this.bridge = new Bridge(l1ProviderOptions, this.providerOptions, this.contractAddressMap);
            }
            return this.bridge;
        };
        this.getNativeTokenBalance = async (address) => {
            const provider = getProvider(this.providerOptions, ChainLayer.L2);
            const balance = await provider.getBalance(address);
            return new Fraction(balance).shr(18);
        };
        this.getTokenDistributor = (signerOrProvider) => {
            return new TokenDistributor({
                address: this.getContractAddress('TokenDistributor'),
                signerOrProvider,
            });
        };
    }
    toJSON() {
        return JSON.stringify({
            chainId: this.providerOptions.chainId,
        });
    }
}
